import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../components/common';
import { DetailFooterBar, FooterLicenseText } from './styled';

/**
 * Footer for the "Listing Details from REGA" view: the ad-license number on the start and the
 * primary Post Now action at the end. Extracted so the detail view doesn't inline its own footer.
 */
const RegaDetailFooter = ({ licenseNo, onPostLicense, isMobile = false }) => {
  const { t } = useTranslation();

  return (
    <DetailFooterBar $isMobile={isMobile}>
      <FooterLicenseText>{licenseNo ? t('Ad License {{no}}', { no: licenseNo }) : ''}</FooterLicenseText>
      <Button
        type="primary"
        size="large"
        disabled={!licenseNo}
        onClick={() => licenseNo && onPostLicense(licenseNo)}
      >
        {t('Post Now')}
      </Button>
    </DetailFooterBar>
  );
};

export default RegaDetailFooter;
